<template>
  <div class="landing">
    <div class="back background" :class="{'fade-in': entered}" :style="{backgroundPosition: 'center ' + ratio + 'px'}"></div>
    <div class="head background" :class="{'fade-in': entered}" :style="{backgroundPosition: 'center ' + ratio + 'px', transform: 'translate3d(0, ' + offset * -0.1 + 'px, 0)'}"></div>
    <div class="logo background" :class="{'shadow': entered}" :style="{backgroundPosition: 'center ' + ratio + 'px'}"></div>
    <div class="front background" :class="{'fade-in': entered}" :style="{backgroundPosition: 'center ' + ratio + 'px', transform: 'translate3d(0, ' + offset * -0.2 + 'px, 0)'}"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      entered: false,
      offset: 0
    }
  },
  computed: {
    windowWidth () {
      return window.innerWidth
    },
    windowHeight () {
      return window.innerHeight
    },
    ratio () {
      return (this.windowWidth / this.windowHeight) > (16 / 9) ? (((16 / 9) / (this.windowWidth / this.windowHeight)) * this.windowHeight - this.windowHeight) / 2 : 0
    }
  },
  mounted () {
    window.addEventListener("scroll", () => {
      this.offset = window.pageYOffset
    })

    setTimeout(() => {
      this.entered = true
    }, 1200)
  }
}
</script>

<style>
@keyframes logoShadow {
  0% {
    filter: drop-shadow(0 0 #be3176);
  }

  100% {
    filter: drop-shadow(6px 6px #be3176);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.landing {
  position: relative;
  width: 100vw;
  height: 100vh;
}

.background {
  position: fixed;
  background-size: contain;
  background-repeat: no-repeat;
  top: 0;
  right: 0;
  left: 0;
  height: 100vh;
}

.back {
  background-image: url('./eov-back.jpg');
}

.head {
  background-image: url('./eov-head.png');
}

.front {
  background-image: url('./eov-front.png');
  background-size: 100vw;
}

.back, .head, .front {
  opacity: 0;
}

.fade-in {
  animation: fadeIn 0.8s ease-out;
  opacity: 1;
}

.logo {
  background-image: url('./logo.png');
  filter: drop-shadow(0px 0px #be3176);
}

.shadow {
  animation: logoShadow 0.2s ease-out;
  filter: drop-shadow(6px 6px #be3176);
}

@media (max-width: 100vh) {
  .background {
    background-size: 100vh;
    background-position: center top;
  }
}
</style>



// WEBPACK FOOTER //
// src/assets/eov/Landing.vue